<div>
    <div class="modal-body">
        <form #form="ngForm">
            <div class="form-row align-items-end">

                <div class="form-group col-md-12 hasValue">
                    <label>{{'Funktionen'|translate}} </label>
                    <kendo-multiselect (valueChange)="onSelectedFunctionsChange()" name="functions" [data]="functions"
                        textField="role" [(ngModel)]="emailNotification.selectedFunctions" valueField="id">
                    </kendo-multiselect>
                </div>

                <div class="form-group col-md-12 hasValue">
                    <label>{{'Employees'|translate}} </label>
                    <kendo-multiselect required name="employees" [data]="employees" textField="fullName"
                        [kendoDropDownFilter]="{ caseSensitive: false, operator: 'contains' }" [filterable]="true"
                        [(ngModel)]="emailNotification.selectedEmployees" valueField="id">
                    </kendo-multiselect>
                </div>

                <div class="form-group hasValue col-md-12 hasValue">
                    <label>{{'Betreff'|translate}}</label>
                    <input type="text" [(ngModel)]="emailNotification.subject" class="form-control" ngModel
                        name="subject" required>
                </div>

                <div class="form-group col-md-12 hasValue">
                    <label>{{ "Description" | translate }} *</label>
                    <kendo-editor [(ngModel)]="emailNotification.description" required #description="ngModel"
                        name="description">
                    </kendo-editor>
                </div>

            </div>
        </form>
    </div>
    <div class="modal-footer d-flex justify-content-between">

        <button (click)="openHistoryModal()" class="btn btn-open m-0 mr-1" type="button">
            {{ "history" | translate | titlecase }}
        </button>

        <div class="d-flex">
            <button class="btn-save" [disabled]="!form.valid || onSaving" (click)="sendNotification()" kendoButton
                primary="true">
                <i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i>
                {{ "save" | translate }}
            </button>
            <button kendoButton class="btn-cancel" (click)="closeDialog()" type="button" primary="true">
                {{ "conclude" | translate }}
            </button>
        </div>
    </div>
</div>

<kendo-dialog title="{{ 'Email Notificationen History' | translate }}" *ngIf="historyDialog.show"
    (close)="historyDialog.show = false" [height]="1000" [width]="1850">
    <div class="modal-body">

        <div class="hasValue form-group col-md-3">
            <label>{{'Version Nr.'|translate}}</label>
            <input type="text" class="mnc-control" name="searchVersionNrValue" [(ngModel)]="searchVersionNrValue" ngModel
                #searchVersion="ngModel" >
        </div>

        <div class="table-responsive">
            <table class="table table-import">
                <thead>
                    <tr>
                        <th>{{ "Version Nr." | translate }}</th>
                        <th>{{ "Functions" | translate }}</th>
                        <th>{{ "Mitarbeiter" | translate }}</th>
                        <th>{{ "Beschrieb" | translate }}</th>
                        <th>{{ "Betreff" | translate }}</th>
                        <th>{{ "Ersteller" | translate }}</th>
                        <th>{{ "date" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of historyDialog.data | filter:'versionNr' : searchVersionNrValue; let i = index">
                        <td>{{ item.versionNr }}</td>
                        <td>{{ item.functions }}</td>
                        <td>{{ item.employees }}</td>
                        <td [innerHTML]="item.description"></td>
                        <td>{{ item.subject }}</td>
                        <td>{{ item.fullName }}</td>
                        <td>{{ item.created_at | date: 'dd.MM.yyyy HH:mm' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button kendoButton class="btn-cancel" (click)="historyDialog.show = false" type="button" primary="true">
            {{ "conclude" | translate }}
        </button>
    </div>
</kendo-dialog>